/**
 * Site
 */
import Config from './Config';

const Site = {
  race: ( data: any ) => {
    const reserved = (Config.isUuid && !!data.reservedFields) ? data.reservedFields.reserved1 || '' : data.reserved1 || '';
    if ( reserved && reserved.contents && reserved.contents.raceName ) {
      return `<span class="race">${reserved.contents.raceName}</span>`;
    }

    return '';
  },

  profileImg: ( data: any, defaultImage = '' ) => {
    return (data && data.contents && data.contents.profileImageUrl ) ? data.contents.profileImageUrl : defaultImage;
  },

  isServerMaster: ( data: any ) => {
    const metaTags = (
        data &&
        data.article &&
        data.article.contentMeta &&
        data.article.contentMeta.metaTags ) ?
        data.article.contentMeta.metaTags : [];
    return (metaTags[0] === 'servermaster');
  },

  characterUrl: ( data: any ) => {
    const reserved = (Config.isUuid && !!data.reservedFields) ? data.reservedFields.reserved2 || '' : data.reserved2 || '';
    if ( reserved && reserved.contents ) {
      return reserved.contents.characterUrl;
    }

    return '';
  },

  sandboxUrl: ( data: any ) => {
    const reserved = (Config.isUuid && !!data.reservedFields) ? data.reservedFields.reserved2 || '' : data.reserved2 || '';
    if ( reserved && reserved.contents ) {
      return reserved.contents.sandboxUrl;
    }

    return '';
  },

  runningTime: ( data: any ) => {
    const reserved = (Config.isUuid && !!data.reservedFields) ? data.reservedFields.reserved2 || '' : data.reserved2 || '';
    if ( reserved && reserved.contents && reserved.contents.runningTime ) {
      return `<span class="running-time">${reserved.contents.runningTime}</span>`;
    }

    return '';
  },

  userInfo: ( data: any ) => {
    const reserved = (Config.isUuid && !!data.reservedFields) ? data.reservedFields.reserved3 || '' : data.reserved3 || '';
    return reserved.contents || {};
  },
};

export default Site;
